import React from 'react';
import { Reveal } from './ui/Reveal';
import { problems } from '../data/content';
export function ProblemSection() {
  return <section aria-labelledby="problema" className="bg-white text-noche-dark" data-id="element-125" data-mp="2ltmglpx0jlk0">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-126" data-mp="30hhavaqo5xz7">
        <p className="inline-block rounded-md bg-noche px-2 py-0.5 font-sub text-sm font-extrabold text-oro" data-id="element-127" data-mp="2vqr7u45pu77o">
          ¿Te suena familiar?
        </p>
        <h2 id="problema" className="mt-2 font-display text-[1.35rem] uppercase leading-[1.12] text-noche sm:text-3xl" data-id="element-128" data-mp="39gb6oyw6ekbp">
          Querés enseñar o estudiar Lengua y Literatura,{' '}
          <span className="bg-oro px-1 text-noche" data-id="element-129" data-mp="3jfaekf94abxn">
            pero te cuesta encontrar todo el material organizado en un solo
            lugar.
          </span>
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-noche-dark/80" data-id="element-130" data-mp="1p2u2uyxjy5le">
          Si sos docente, estudiante o estás preparando clases y evaluaciones,
          probablemente conozcas alguna de estas situaciones:
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-131" data-mp="jbafr5dl3lhu">
          {problems.map((problem, i) => <Reveal key={problem.title} as="li" delay={i * 0.03} className="h-full rounded-xl border-2 border-noche bg-ciencia-light p-2.5 text-left" data-id="element-132" data-mp="o9u051cj4p83" data-mpi={i}>
              <h3 className="font-sub text-sm font-extrabold leading-tight text-noche" data-id="element-133" data-mp="123v181qyeobm">
                {problem.title}
              </h3>
              <p className="mt-0.5 text-xs leading-snug text-noche-dark/80 sm:text-sm" data-id="element-134" data-mp="171elbiac1vbh">
                {problem.desc}
              </p>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}